/**
 * `storage_kind` on identity uploads (svc-identity-verification). New rows are `platform` (object storage via
 * platform-sdk); rows written before that migration say `azure` and live in the same storage. A missing kind
 * means object storage, as before.
 */
export const OBJECT_STORAGE_KIND = 'platform';

/** True for object-storage rows (`platform`, legacy `azure`, or no kind): previews use signed links. */
export function isObjectStorageKind(kind: string | null | undefined): boolean {
  const k = (kind ?? '').trim().toLowerCase();
  return k === '' || k === OBJECT_STORAGE_KIND || k === 'azure';
}
